const BASE_URL = process.env.REACT_APP_BASE_URL;

export const LOGIN = "auth/login";
export const GET_PROFILE = BASE_URL + "admin/auth/profile";

export const ADMIN_LOCATIONS = "admin/location";

export const ADMIN_ROLES = "admin/roles";
export const ALL_BANKS = "public/banks";
export const ADMIN_DEPTS = "admin/department";
export const ADMIN_JOBS = "admin/job-title";
export const PERFORMANCE_MEASURE =
  "admin/performance-review/performance-measure/all";
export const PERFORMANCE_TEAMS = "admin/performance-review/team/all";
export const PERFORMANCE_TEAM_DETAILS = "admin/performance-review/team";
export const PERFORMANCE_REVIEWS = "admin/performance-review/staff-review/all";
export const PERFORMANCE_METRICS = "/admin/performance-review/metrics";
export const PERFORMANCE_REVIEW =
  "admin/performance-review/staff-review/details";
export const PERFORMANCE_CYCLES =
  "admin/performance-review/performance-review-cycle";
export const PAYROLL = "admin/payroll";
export const ALL_PERFORMANCE_CYCLES =
  "admin/performance-review/performance-review-cycle/all";
export const ADMIN_JOB = (id = "") => `admin/job-title/${id}`;
export const ADMIN_PERMISSIONS = "admin/permissions";
export const ADMIN_ROLES_PERMISSIONS = "admin/roles/permissions";
export const ADMIN_ROLES_LIST = (filterString = "", limit = "", page = "") =>
  `admin/roles?${filterString}&limit=${limit}&page=${page}&sort=createdAt,DESC`;

export const ADMIN_ROLE = (id = "") => `admin/roles/${id}`;
export const ADMIN_CREATE_REWARD = "admin/performance-review/reward";
export const ADMIN_CREATE_PENALTY = "admin/performance-review/penalty";
export const STAFF_METRICS = "admin/dashboard/staff/metrics";
export const SEND_MESSAGE = "admin/messages/send";
export const DRAFT_MESSAGE = "admin/messages/draft";
export const GET_MESSAGES = "admin/messages";
export const UPDATE_MESSAGE = (id = "") => `admin/messages/${id}`;
export const PUBLISH_MESSAGES = "admin/messages/publish";

export const ADMIN_PERMISSIONS_LIST = (
  filterString = "",
  limit = "",
  page = "",
) =>
  `admin/permissions?${filterString}&limit=${limit}&page=${page}&sort=createdAt,DESC`;

export const ADMIN_PERMISSION = (id = "") => `admin/permissions/${id}`;

export const UPLOAD_MEDIA = "system/media-upload";

export const STAFFS = "/admin/staff";
export const ADMINS = "/admin/users";
export const VENDORS = "/admin/inventory/vendor";
export const UPDATE_VENDOR = (id = "") => `admin/inventory/vendor/${id}`;
export const UPDATE_ITEM = (id = "") => `admin/inventory/stock-item/${id}`;
export const SEND_MAINTAIN = (id = "") =>
  `/admin/inventory/maintenance-request/send-for-maintenance/${id}`;
export const UPDATE_CAT = (id = "") => `admin/inventory/item-category/${id}`;
export const DEPTS = "/admin/department";
export const CATEGORIES = "/admin/inventory/item-category";
export const PROCUREMENT = "/admin/inventory/procurement";
export const ISSUANCE = "/admin/inventory/issuance";
export const DEPT = (id = "") => `/admin/department/${id}`;
export const REQUEST_LEAVE = "admin/leave-request";
export const REQUEST_MED = "admin/medical-assistance";
export const REQUEST_LOAN = "admin/loan-request";
export const PERFORMANCE = "admin/performance-review";
export const ADMIN_REQUEST_LEAVE = (id = "") => `admin/leave-request/${id}`;
export const ADMIN_REQUEST_LOAN = (id = "") => `admin/loan-request/${id}`;
export const STAFF_LIST = (filterString = "", limit = "", page = "") =>
  `admin/staff?${filterString}&limit=${limit}&page=${page}&sort=createdAt,DESC`;
export const STAFF = (id = "") => `admin/staff/${id}`;
export const EDIT_PAYROLL = (id = "") => `admin/payroll/${id}`;
export const TOGGLE_PAYROLL = (id = "") => `admin/payroll/${id}/toggle-flag`;
export const PEN = (id = "") => `/admin/performance-review/penalty/${id}`;
export const REW = (id = "") => `/admin/performance-review/reward/${id}`;
export const ADMIN = (id = "") => `admin/users/${id}`;
export const ACTIVATE_STAFF = (id = "") => `admin/staff/activate/${id}`;
export const TERMINATE_STAFF = (id = "") => `admin/staff/terminate/${id}`;
export const UPDATE_EMPLOYEE_DOC = (id = "") =>
  `admin/employee-documents/${id}`;
export const UPDATE_DEPT = (id = "") => `admin/department/${id}`;
export const GET_STAFF_LEAVE_BALANCE = (id = "") =>
  `admin/leave-request/leave-balance/${id}`;
export const GET_STAFF_LOAN_BALANCE = (id = "") =>
  `admin/loan-request/loan-balance/${id}`;
export const APPROVE_LICENSE = (id = "") =>
  `admin/staff/approve-driver-license/${id}`;
export const EMPLOYEE_DOC = "admin/employee-documents";

export const APPROVE_LEAVE = (id = "") => `admin/leave-request/approve/${id}`;
export const REJECT_LEAVE = (id = "") => `admin/leave-request/reject/${id}`;
export const APPROVE_LOAN = (id = "") => `admin/loan-request/approve/${id}`;
export const APPROVE_MED = (id = "") =>
  `admin/medical-assistance/approve/${id}`;
export const LOAN_PAID = (id = "") =>
  `admin/loan-request/${id}/repayment-plan/set-to-paid`;
export const DISBURSE_LOAN = (id = "") => `admin/loan-request/disburse/${id}`;
export const REJECT_LOAN = (id = "") => `admin/loan-request/decline/${id}`;
export const REJECT_MED = (id = "") => `admin/medical-assistance/decline/${id}`;

export const APPROVE_PAY = (id = "") => `admin/payment-requests/approve/${id}`;
export const REJECT_PAY = (id = "") => `admin/payment-requests/deny/${id}`;
export const DISBURSE_PAY = (id = "") =>
  `admin/payment-requests/disburse/${id}`;

export const UPDATE_ADMIN_PROFILE = "/admin/update-profile";
export const UPDATE_ADMIN_PASSWORD = "/admin/update-password";
export const ADMIN_CREATE_SCHEDULE_BY_LOCATION =
  "/admin/schedule/create-by-location";
export const ADMIN_EDIT_SCHEDULE_BY_LOCATION = "/admin/schedule/location";
export const ADMIN_CREATE_SCHEDULE_BY_STAFF = "/admin/schedule/create-by-staff";
export const GET_SCHEDULES = "/admin/schedule/week";
export const GET_SCHEDULE_WEEK = "/admin/schedule/location/week";

export const GET_SCHEDULES_DAY = (
  week = "",
  day = "",
  page = "",
  limit = "",
  search = "",
) =>
  `/admin/schedule/day?week=${week}&dayOfWeek=${day}&page=${page}&limit=${limit}&search=${search}`;

export const GET_SCHEDULES_LOCATION = (week = "", day = "", id = "") =>
  `/admin/schedule/location?week=${week}&dayOfWeek=${day}&locationId=${id}`;
export const DEL_SCHEDULES_LOCATION = (id = "") => `/admin/schedule/day/${id}`;

export const GET_SCHEDULES_LOCATION_WEEK = "/admin/schedule/location";
export const ADD_CAT = "/admin/inventory/item-category";
export const ADD_ITEM = "/admin/inventory/stock-item";
export const ADD_KPI = "/admin/performance-review/performance-measure";
export const ADD_TEAM = "/admin/performance-review/team";
export const REVIEW = "/admin/performance-review/staff-review";
export const ADD_QUESTION =
  "/admin/performance-review/performance-measure/question";
export const UPDATE_QUESTION = (id = "") =>
  `/admin/performance-review/performance-measure/question/${id}`;
export const UPDATE_CYCLE = (id = "") =>
  `/admin/performance-review/performance-review-cycle/${id}`;
export const UPDATE_TEAM = (id = "") => `/admin/performance-review/team/${id}`;
export const REQS = "/admin/inventory/requisition";
export const MAINTENANCE = "/admin/inventory/maintenance-request";
export const UPDATE_REQ = (id = "") => `admin/inventory/requisition/${id}`;
export const UPDATE_ISSUANCE = (id = "") => `admin/inventory/issuance/${id}`;
export const INVENT_METRICS = "/admin/inventory/metrics";
export const APP_REQ = (type = "", id = "") =>
  `/admin/inventory/procurement/${type}/${id}`;
export const APP_ISSUANCE = (type = "", id = "") =>
  `/admin/inventory/issuance/${type}/${id}`;
export const APP_REV = (staffId = "", performanceReviewCycleId = "") =>
  `/admin/performance-review/staff-review/approve?staffId=${staffId}&performanceReviewCycleId=${performanceReviewCycleId}`;
export const DENY_REV = "/admin/performance-review/staff-review/deny";
export const COMPLETE_MAINTAIN = (id = "") =>
  `/admin/inventory/maintenance-request/complete/${id}`;

export const EXPORT_REVIEWS = () =>
  `/admin/performance-review/staff-review/export`;
export const EXPORT_PENALTIES = () =>
  `/admin/performance-review/penalty/export`;
export const EXPORT_REWARDS = () => `/admin/performance-review/reward/export`;

export const REQUEST = "/admin/payment-requests";

export const LICENSE_REPORT = "/admin/reports/driver-licenses";
export const LICENSE_REPORT_EXPORT = "/admin/reports/driver-licenses/export";
export const PAYROLL_EXPORT = "/admin/payroll/export";
export const LICENSE_REPORT_METRICS = "/admin/reports/driver-licenses/metrics";
export const LOAN_REPORT = "/admin/reports/loan-requests";
export const LOAN_REPORT_EXPORT = "/admin/reports/loan-requests/export";
export const LOAN_REPORT_METRICS = "/admin/reports/loan-requests/metrics";
export const LEAVE_REPORT = "/admin/reports/leave-requests";
export const LEAVE_REPORT_EXPORT = "/admin/reports/leave-requests/export";
export const LEAVE_REPORT_METRICS = "/admin/reports/leave-requests/metrics";
export const MEDICAL_REPORT = "/admin/reports/medical-assistance";
export const MEDICAL_REPORT_EXPORT = "/admin/reports/medical-assistance/export";
export const MEDICAL_REPORT_METRICS =
  "/admin/reports/medical-assistance/metrics";
export const PENALTY_REPORT = "/admin/reports/penalty";
export const PENALTY_REPORT_EXPORT = "/admin/reports/penalty/export";
export const PENALTY_REPORT_METRICS = "/admin/reports/penalty/metrics";

// exports
export const ADMIN_EXPORT = "/admin/users/export";
export const STAFF_EXPORT = "/admin/staff/export";
export const LEAVE_EXPORT = "/admin/leave-request/export";
export const LOAN_EXPORT = "/admin/loan-request/export";
export const MED_EXPORT = "/admin/medical-assistance/export";
export const DEPT_EXPORT = "/admin/department/export";
export const JOB_EXPORT = "/admin/job-title/export";
export const ROLE_EXPORT = "/admin/roles/export";
export const PERMISSION_EXPORT = "/admin/permissions/export";
export const PERFORMANCE_EXPORT = "/admin/performance-review/export";
export const MEASURE_EXPORT =
  "/admin/performance-review/performance-measure/export";
export const TEAM_EXPORT = "/admin/performance-review/team/export";
export const CYCLE_EXPORT =
  "/admin/performance-review/performance-review-cycle/export";
export const CATEGORY_EXPORT = "/admin/inventory/item-category/export";
export const STOCK_ITEM_EXPORT = "/admin/inventory/stock-item/export";
export const REQUISITION_EXPORT = "/admin/inventory/requisition/export";
export const ISSUANCE_EXPORT = "/admin/inventory/issuance/export";
export const PROCUREMENT_EXPORT = "/admin/inventory/procurement/export";
export const VENDOR_EXPORT = "/admin/inventory/vendor/export";
export const MAINTAIN_EXPORT = "/admin/inventory/maintenance-request/export";
export const MESSAGES_EXPORT = "/admin/messages/export";
export const PAY_REQ_EXPORT = "/admin/payment-requests/export";
export const DRIVER_REP_EXPORT = "/admin/reports/driver-licenses/export";
export const LOAN_REP_EXPORT = "/admin/reports/loan-requests/export";
export const LEAVE_REP_EXPORT = "/admin/reports/leave-requests/export";
export const MED_REP_EXPORT = "/admin/reports/medical-assistance/export";
export const PENALTY_REP_EXPORT = "/admin/reports/penalty/export";
